export default __webpack_public_path__ + "static/media/referenzen.92c40b1d.webp";